<template>
  <section class="section privacy">
    <b-container>
      <div class="privacy-card card-cbp" v-reveal>
        <span class="eyebrow">Hot Pursuit</span>
        <h1 class="privacy-title">Politique de confidentialité</h1>

        <h2>Informations collectées</h2>
        <p>Aucune information n'est collectée.</p>

        <h2>Contact</h2>
        <p>
          Contactez-nous par email à
          <a href="mailto:club.babypro@gmail.com">club.babypro@gmail.com</a>.
        </p>
      </div>
    </b-container>
  </section>
</template>

<script>
export default {
  name: 'PrivacyView'
}
</script>

<style scoped lang="scss">
  .privacy {
    display: flex;
    align-items: center;
    min-height: 60vh;
  }
  .privacy-card {
    max-width: 760px;
    margin: 0 auto;
    padding: clamp(2rem, 5vw, 3.5rem);
    text-align: left;
  }
  .privacy-title {
    font-family: 'fightt', sans-serif;
    font-size: clamp(2rem, 5vw, 3rem);
    margin-bottom: 2rem;
  }
  .privacy-card h2 {
    font-size: 1.4rem;
    margin-top: 1.75rem;
    color: var(--gold);
  }
  .privacy-card p {
    color: var(--text-muted);
  }
  .privacy-card a {
    color: var(--gold);
  }
  .privacy-card a:hover {
    text-decoration: underline;
  }
</style>
